import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Button, Grid, Divider } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import PeopleIcon from "@mui/icons-material/People";
import { fetchProject } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import DetailSection from "../../components/common/DetailSection";
import DetailField from "../../components/common/DetailField";

export default function BuildProjectDetailPage() {
  const { businessDomainId, businessUnitId, projectId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const [data, setData] = useState(null);

  const basePath = `/build/${businessDomainId}/business-units/${businessUnitId}/projects/${projectId}`;

  const loadData = useCallback(async () => {
    try { setData(await fetchProject(projectId)); }
    catch (e) { notify.apiError(e); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  useEffect(() => { loadData(); }, [loadData]);

  if (!data) return null;

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{t("project.detail.title")}</Typography>
      </Box>

      <DetailSection>
        <Grid container spacing={2}>
          <Grid size={12}>
            <DetailField label={t("project.name")} value={data.projectName} />
          </Grid>
          <Grid size={12}>
            <DetailField label={t("project.description")} value={data.projectDescription} />
          </Grid>
        </Grid>
      </DetailSection>

      <Divider sx={{ my: 3 }} />
      <Box>
        <Button variant="outlined" startIcon={<PeopleIcon />}
          onClick={() => navigate(`${basePath}/members`)}>
          {t("project.member.list.title")}
        </Button>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Button variant="outlined" onClick={() => navigate(`/build/${businessDomainId}/business-units/${businessUnitId}/projects`)}>{t("common.back")}</Button>
      </Box>
    </Box>
  );
}
